import devices, { getDeviceApiUrl, getDevicesApiUrl, searchDevicesApiUrl } from '../apis/devices';
import drivers, { getDriversApiUrl, getDriverApiUrl, getCountApiUrl, putCountApiUrl, getPropertiesApiUrl, getDefaultsApiUrl, getAstroSavingsApiUrl, getOpmodesApiUrl, getOpmodesSelectedApiUrl, getFeaturesApiUrl, getPermissionsApiUrl, postDriverxmlRefApiUrl, postDriverApiUrl, patchDriverApiUrl, putOpmodesSelectedApiUrl, getProgrammingSelectionApiUrl, putProgrammingSelectionApiUrl, putProgrammingSingleSelectionApiUrl, getLockedFeatures, patchDriverNamedProps } from '../apis/drivers';
import lumInfos, { getLumInfosApiUrl, getLumInfosTypeApiUrl, updateLumInfosTypeApiUrl, getLumInfosPropertiesApiUrl, updateLumInfosPropertiesApiUrl } from '../apis/lumInfos';
import ledModules, { getLedModulesSelectedApiUrl, updateLedModulesSelectedApiUrl, getLedModulesPropertiesApiUrl, updateLedModulesPropertiesApiUrl } from '../apis/ledmodules';
import ledModuleStore, { getLedModulesApiUrl } from '../apis/ledmodulestore';
import projects, { getHeaderWarningUrl, getProjectBrandUrl, generateProjectApiUrl, verifyProjectApiUrl, copyProjectApiUrl, getProjectApiUrl, getProjectsApiUrl, searchProjectsApiUrl, postProjectsApiUrl, putProjectApiUrl, downloadProjectApiUrl, importProjectApiUrl, luminaireImageProjectApiUrl, luminaireImageProjectApiUrlCompleted, projectOptionsApiUrl, getProjectLocationApiUrl, putProjectLocationApiUrl, getProjectReportApiUrl, getallVersionsApiUrl } from '../apis/projects';
import auth, { postLoginApiUrl } from '../apis/auth';

import PropertiesWorker from "../workers/properties.worker.js";
import WebWorker from "../workers/workerSetup.js";

import {
    SIGN_IN_RESET,
    SIGN_IN_OK,
    SIGN_IN_FAILURE,
    FETCH_BRAND,
    FETCH_HEADER_WARNING,

    SEARCH_PROJECTS,
    FETCH_PROJECTS,
    RESET_PROJECTS,
    FETCH_PROJECT_REPORT,

    FETCH_PROJECT,
    CREATE_PROJECT,
    UPDATE_PROJECT,
    DELETE_PROJECT,
    COPY_PROJECT,
    VERIFY_PROJECT,
    GENERATE_PROJECT,
    DOWNLOAD_PROJECT,
    FETCH_PROJECT_LOCATION,
    UPDATE_PROJECT_LOCATION,

    RESET_PROJECT,
    SET_TEMPORARY_PROJECT,

    FETCH_ALL_VERSIONS,

    SEARCH_DEVICES,
    FETCH_DEVICES,
    FETCH_DEVICE,

    ERROR_PROJECT_NOT_FOUND,

    ADD_DRIVER,
    FETCH_DRIVERS,
    FETCH_DRIVER,
    FETCH_DRIVER_COUNT,
    FETCH_DRIVER_PROPERTIES,
    FETCH_DRIVER_DEFAULTS,
    FETCH_DRIVER_OPMODES,
    FETCH_DRIVER_OPMODES_SELECTED,
    UPDATE_DRIVER_OPMODES_SELECTED,
    FETCH_DRIVER_FEATURES,
    FETCH_DRIVER_PERMISSIONS,
    FETCH_LOCKED_FEATURES,
    FETCH_DRIVER_PROGRAMMING_SELECTION,
    UPDATE_DRIVER_PROGRAMMING_SELECTION,
    UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION,
    UPDATE_DRIVERS,
    UPDATE_DRIVER_COUNT,
    RESET_DRIVER,
    UPDATE_DRIVER,
    DELETE_DRIVER,
    FETCH_ASTRO_SAVINGS,

    SEARCH_STARTED,
    SEARCH_ENDED,
    SEARCH_PARAM_CHANGED,

    FETCH_LUMINFOS,
    GET_TYPE_LUMINFOS,
    UPDATE_TYPE_LUMINFOS,
    FETCH_PROPERTIES_LUMINFOS,
    UPDATE_PROPERTIES_LUMINFOS,

    ERROR_ADD,
    ERROR_REMOVE,
    NOT_FOUND_ERROR_REMOVE,
    ERROR_DELETE,
    ALL_ERRORS_REMOVE,

    FETCH_PROJECT_OPTIONS,
    UPDATE_PROJECT_OPTIONS,

    LUMINAIRE_IMAGE_PROJECT,

    FETCH_LEDMODULES,
    GET_SELECTED_LEDMODULES,
    UPDATE_SELECTED_LEDMODULES,
    FETCH_PROPERTIES_LEDMODULES,
    UPDATE_PROPERTIES_LEDMODULES
} from './types';

export const propertiesWorker = new WebWorker(PropertiesWorker);

/*
 *  AUTH
 */

export const signInReset = () => async dispatch => {
    dispatch({ type: SIGN_IN_RESET, payload: null });
}

export const signIn = () => async dispatch => {
    await auth.get(postLoginApiUrl())
        .then(response => {
            dispatch({ type: SIGN_IN_OK, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: SIGN_IN_FAILURE, payload: error.data });
        });
};

/*
 *  PROJECTS
 */

export const fetchHeaderWarning = () => async dispatch => {
    const response = await projects.get(getHeaderWarningUrl());
    dispatch({type: FETCH_HEADER_WARNING, payload: response.data});
};

export const fetchBrand = () => async dispatch => {
    const response = await projects.get(getProjectBrandUrl());
    dispatch({type: FETCH_BRAND, payload: response.data});
};

export const fetchProjects = () => async dispatch => {
    const response = await projects.get(getProjectsApiUrl());
    dispatch({ type: FETCH_PROJECTS, payload: response.data });
};

export const searchProjects = (searchString, filterParam) => async dispatch => {
    const response = await projects.get(searchProjectsApiUrl(searchString, filterParam));
    dispatch({ type: SEARCH_PROJECTS, payload: response.data });
};

export const resetProjects = () => async dispatch => {
    dispatch({ type: RESET_PROJECTS });
};

export const fetchProject = (id) => async dispatch => {
    await projects.get(getProjectApiUrl(id))
        .then(response => {
            dispatch({ type: FETCH_PROJECT, payload: response.data });
        })
        .catch(error => {
            if (error.response.status === 404) {
                error.response.projectId = id;
                dispatch({ type: ERROR_PROJECT_NOT_FOUND, error: error.response });
            } else {
                dispatch({ type: ERROR_ADD, error: error.response });
            }
        });
};

export const fetchReportFromProject = (id) => async dispatch => {
    const response = await projects.get(getProjectReportApiUrl(id), { responseType: 'stream' })
    dispatch({ type: FETCH_PROJECT_REPORT, payload: response });
}

export const createProject = (project) => async dispatch => {
    await projects.post(postProjectsApiUrl(project))
        .then(projectId => {
            dispatch({ type: CREATE_PROJECT, payload: projectId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const updateProject = (id, project) => async dispatch => {
    const response = await projects.put(putProjectApiUrl(id, project));
    dispatch({ type: UPDATE_PROJECT, payload: response.data });
};

export const verifyProject = id => async dispatch => {
    const response = await projects.get(verifyProjectApiUrl(id));
    dispatch({ type: VERIFY_PROJECT, payload: response.data });
};

export const generateProject = id => async dispatch => {
    //const response = await projects.get(generateProjectApiUrl(id));
    await projects.get(generateProjectApiUrl(id))
        .then((response) => {
            dispatch({ type: GENERATE_PROJECT, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const downloadProject = (id, downloadId) => async dispatch => {
    const response = await projects.get(downloadProjectApiUrl(id, downloadId), { responseType: 'blob' });
    dispatch({ type: DOWNLOAD_PROJECT, payload: response });
};

export const importProject = file => async dispatch => {
    const formData = new FormData();
    formData.append('file', file);
    await projects.post(importProjectApiUrl(), formData)
        .then(projectId => {
            dispatch({ type: CREATE_PROJECT, payload: projectId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const copyProject = (id, name) => async dispatch => {
    const response = await projects.post(copyProjectApiUrl(id, name));
    dispatch({ type: COPY_PROJECT, payload: response.data });
};

export const uploadLuminaireImageProject = (id, file) => async dispatch => {
    const formData = new FormData();
    formData.append('file', file);
    await projects.post(luminaireImageProjectApiUrl(id), formData);
};

export const retrieveLuminaireImageProject = (id) => async dispatch => {
    const response = await projects.get(luminaireImageProjectApiUrlCompleted(id), { responseType: 'blob' });
    dispatch({ type: LUMINAIRE_IMAGE_PROJECT, payload: response.data });
};

export const resetProject = () => async dispatch => {
    dispatch({ type: RESET_PROJECT });
};

export const deleteProject = (id) => async dispatch => {
    await projects.delete(getProjectApiUrl(id))
        .then(response => {
            dispatch({ type: DELETE_PROJECT, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const fetchProjectLocation = (id) => async dispatch => {
    const response = await projects.get(getProjectLocationApiUrl(id))
    dispatch({ type: FETCH_PROJECT_LOCATION, payload: response.data });
};

export const updateProjectLocation = (id, latitude, longitude, timeZone) => async dispatch => {
    const response = await projects.put(putProjectLocationApiUrl(id), { latitude, longitude, timeZone })
    dispatch({ type: UPDATE_PROJECT_LOCATION, payload: response.data });
};

export const fetchAllVersions = () => async dispatch => {
    const response = await projects.get(getallVersionsApiUrl());
    dispatch({ type: FETCH_ALL_VERSIONS, payload: response.data });
};

/*
 *  DEVICES
 */

export const fetchDevices = () => async dispatch => {
    const response = await devices.get(getDevicesApiUrl());
    dispatch({ type: FETCH_DEVICES, payload: response.data });
};

export const searchDevices = (searchString, filterParam) => async dispatch => {
    const response = await devices.get(searchDevicesApiUrl(searchString, filterParam, "cloud"));
    dispatch({ type: SEARCH_DEVICES, payload: response.data });
};

export const fetchDevice = id => async dispatch => {
    const response = await devices.get(getDeviceApiUrl(id));
    dispatch({ type: FETCH_DEVICE, payload: response.data });
};

/*
 *  DRIVERS
 */

export const addDriverByGTIN = (projectId, driverId, fwVersion, hwVersion) => async dispatch => {
    await drivers.post(postDriverApiUrl(projectId, driverId, fwVersion, hwVersion))
        .then((driverId) => {
            dispatch({ type: ADD_DRIVER, payload: driverId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const addDriver = (projectId, device) => async dispatch => {
    await drivers.post(postDriverxmlRefApiUrl(projectId, device.xmlRef))
        .then((driverId) => {
            dispatch({ type: ADD_DRIVER, payload: driverId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const updateDriver = (driver) => async dispatch => {
    dispatch({ type: UPDATE_DRIVER, payload: driver });
};

export const deleteDriver = (projectId, driverId) => async dispatch => {
    await drivers.delete(getDriverApiUrl(projectId, driverId))
        .then(response => {
            dispatch({ type: DELETE_DRIVER, payload: driverId });
        })
        .catch(error => {
            dispatch({ type: ERROR_DELETE, error: error.response });
        });
};

export const fetchDrivers = (projectId) => async dispatch => {
    await drivers.get(getDriversApiUrl(projectId))
        .then(response => {
            dispatch({ type: FETCH_DRIVERS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const fetchDriver = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getDriverApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER, payload: response.data });
};

export const fetchDriverCount = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getCountApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_COUNT, payload: response.data });
};

export const updateDriverCount = (projectId, driverId, count) => async dispatch => {
    const response = await drivers.put(putCountApiUrl(projectId, driverId, count));
    dispatch({ type: UPDATE_DRIVER_COUNT, payload: count });
};

export const fetchDriverProperties = (projectId, driverId, featureId) => async dispatch => {
    const response = await drivers.get(getPropertiesApiUrl(projectId, driverId, featureId));
    dispatch({ type: FETCH_DRIVER_PROPERTIES, payload: response.data });
};

// Factory defaults, straight from the DD store. Distinct from each property's own
// `valueMeta.default`, which on an imported project holds the values read off the device.
export const fetchDriverDefaults = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getDefaultsApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_DEFAULTS, payload: response.data });
};

export const fetchAstroSavings = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getAstroSavingsApiUrl(projectId, driverId));
    dispatch({type: FETCH_ASTRO_SAVINGS, payload: response.data});
}

export const fetchDriverOpmodes = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getOpmodesApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_OPMODES, payload: response.data });
};

export const fetchDriverOpmodesSelected = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getOpmodesSelectedApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_OPMODES_SELECTED, payload: response.data });
};

export const updateDriverOpmodesSelected = (projectId, driverId, opModeId) => async dispatch => {
    const response = await drivers.put(putOpmodesSelectedApiUrl(projectId, driverId, opModeId));
    dispatch({ type: UPDATE_DRIVER_OPMODES_SELECTED, payload: response.data });
};

export const fetchDriverFeatures = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getFeaturesApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_FEATURES, payload: response.data });
};

export const fetchDriverPermissions = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getPermissionsApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_PERMISSIONS, payload: response.data });
};
export const fetchLockedFeatures = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getLockedFeatures(projectId, driverId));
    dispatch({ type: FETCH_LOCKED_FEATURES, payload: response.data });
};

export const fetchDriverProgrammingSelection = (projectId, driverId) => async dispatch => {
    const response = await drivers.get(getProgrammingSelectionApiUrl(projectId, driverId));
    dispatch({ type: FETCH_DRIVER_PROGRAMMING_SELECTION, payload: response.data });
};

export const updateDriverProgrammingSelection = (projectId, driverId, featuresName) => async dispatch => {
    const response = await drivers.put(putProgrammingSelectionApiUrl(projectId, driverId, featuresName));
    dispatch({ type: UPDATE_DRIVER_PROGRAMMING_SELECTION, payload: response.data });
};

export const updateDriverProgrammingSingleSelection = (projectId, driverId, featureName, isToProgram) => async dispatch => {
    const response = await drivers.put(putProgrammingSingleSelectionApiUrl(projectId, driverId, featureName, isToProgram));
    dispatch({ type: UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION, payload: response.data });
};

export const updateDriverProperties = (projectId, driverId, driverProperties) => async dispatch => {
    await drivers.patch(patchDriverApiUrl(projectId, driverId), driverProperties)
        .then(response => {
            dispatch({ type: UPDATE_DRIVERS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });

};

export const updateDriverNamedProperties = (projectId, driverId, driverProperties) => async dispatch => {
    await drivers.patch(patchDriverNamedProps(projectId, driverId), driverProperties)
        .then(response => {
            dispatch({ type: UPDATE_DRIVERS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });

};

export const resetDriver = () => async dispatch => {
    dispatch({ type: RESET_DRIVER });
};

/*
 *  SEARCH
 */

export const changeSearchParam = (searchString, filterParam) => async dispatch => {
    dispatch({ type: SEARCH_PARAM_CHANGED, payload: { searchString, filterParam } });
};

export const startSearching = () => async dispatch => {
    dispatch({ type: SEARCH_STARTED });
};

export const stopSearching = () => async dispatch => {
    dispatch({ type: SEARCH_ENDED });
};

/*
 *  LUMINFOS
 */
export const fetchLumInfos = (projectId, driverId) => async dispatch => {
    const response = await lumInfos.get(getLumInfosApiUrl(projectId, driverId));
    dispatch({ type: FETCH_LUMINFOS, payload: response.data });
};

export const getLumInfosType = (projectId, driverId) => async dispatch => {
    const response = await lumInfos.get(getLumInfosTypeApiUrl(projectId, driverId));
    dispatch({ type: GET_TYPE_LUMINFOS, payload: response.data });
};

export const updateLumInfosType = (projectId, driverId, type) => async dispatch => {
    const response = await lumInfos.put(updateLumInfosTypeApiUrl(projectId, driverId, type));
    dispatch({ type: UPDATE_TYPE_LUMINFOS, payload: response.data });
};

export const getLumInfosProperties = (projectId, driverId) => async dispatch => {
    const response = await lumInfos.get(getLumInfosPropertiesApiUrl(projectId, driverId));
    dispatch({ type: FETCH_PROPERTIES_LUMINFOS, payload: response.data });
};

export const updateLumInfosProperties = (projectId, driverId, properties) => async dispatch => {
    const response = await lumInfos.patch(updateLumInfosPropertiesApiUrl(projectId, driverId), properties);
    dispatch({ type: UPDATE_PROPERTIES_LUMINFOS, payload: response.data });
};

export const getProjectOptions = (projectId) => async dispatch => {
    const response = await projects.get(projectOptionsApiUrl(projectId));
    dispatch({ type: FETCH_PROJECT_OPTIONS, payload: response.data });
};

export const putProjectOptions = (projectId, options) => async dispatch => {
    const response = await projects.put(projectOptionsApiUrl(projectId), options);
    dispatch({ type: UPDATE_PROJECT_OPTIONS, payload: response.data });
};

/*
 *  LEDMODULES
 */
export const fetchLedModules = () => async dispatch => {
    const response = await ledModuleStore.get(getLedModulesApiUrl());
    dispatch({ type: FETCH_LEDMODULES, payload: response.data });
};

export const getLedModulesSelected = (projectId) => async dispatch => {
    const response = await ledModules.get(getLedModulesSelectedApiUrl(projectId));
    dispatch({ type: GET_SELECTED_LEDMODULES, payload: response.data });
};

export const updateLedModulesSelected = (projectId, ledModuleId) => async dispatch => {
    const response = await ledModules.put(updateLedModulesSelectedApiUrl(projectId, ledModuleId));
    dispatch({ type: UPDATE_SELECTED_LEDMODULES, payload: response.data });
};

export const getLedModulesProperties = (projectId) => async dispatch => {
    const response = await ledModules.get(getLedModulesPropertiesApiUrl(projectId));
    dispatch({ type: FETCH_PROPERTIES_LEDMODULES, payload: response.data });
};

export const updateLedModulesProperties = (projectId, properties) => async dispatch => {
    const response = await ledModules.patch(updateLedModulesPropertiesApiUrl(projectId), properties);
    dispatch({ type: UPDATE_PROPERTIES_LEDMODULES, payload: response.data });
};

/*
 *  EXTRA
 */
export const errorRemove = (error) => async dispatch => {
    dispatch({ type: ERROR_REMOVE, error: error });
};
export const notFoundErrorRemove = (error) => async dispatch => {
    dispatch({ type: NOT_FOUND_ERROR_REMOVE, error: error });
};

export const setTemporaryProject = (isTemporary) => async dispatch => {
    dispatch({ type: SET_TEMPORARY_PROJECT, payload: isTemporary });
};

export const allErrorsRemove = () => async dispatch => {
    dispatch({ type: ALL_ERRORS_REMOVE });
};
